import React, { useState } from 'react';
import useLanguage from '../../../../hooks/useLanguage';
import './styles.css';

const LanguageBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language: currentLanguage, changeLanguage } = useLanguage();

  const languages = [
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    // { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
  ];

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  const selectedLanguage = languages.find(lang => lang.code === currentLanguage) || languages[0];


  return (
    <div className="language-bar">
      <div className="language-selector">
        <button 
          className="language-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Selecionar idioma"
        >
          <span className="flag">{selectedLanguage.flag}</span>
          <span className="language-name">{selectedLanguage.name}</span>
          <svg 
            className={`chevron ${isOpen ? 'open' : ''}`}
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </button>

        {isOpen && (
          <div className="language-dropdown">
            {languages.map((language) => (
              <button
                key={language.code}
                className={`language-option ${currentLanguage === language.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(language.code)}
              >
                <span className="flag">{language.flag}</span>
                <span className="language-name">{language.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageBar;